import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import type { HourPoint } from '../../types/weather';
import { chartTheme } from './chartTheme';

export function HourlyPressureChart({ hourly }: { hourly: HourPoint[] }) {
  const data = hourly.map(h => ({ time: h.timeLocal, Pressure: h.pressureHpa }));
  return (
    <div className="h-28">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 6, right: 12, bottom: 0, left: 4 }}>
          <CartesianGrid strokeDasharray="2 4" stroke={chartTheme.grid} vertical={false} />
          <XAxis dataKey="time" tick={chartTheme.tick} interval={3} stroke={chartTheme.grid} />
          <YAxis
            tick={chartTheme.tick}
            width={48}
            stroke={chartTheme.grid}
            domain={['dataMin - 1', 'dataMax + 1']}
            tickFormatter={(v: number) => `${Math.round(v)}`}
          />
          <Tooltip
            contentStyle={chartTheme.tooltip.contentStyle}
            labelStyle={chartTheme.tooltip.labelStyle}
            itemStyle={chartTheme.tooltip.itemStyle}
            formatter={(v) => `${Math.round(Number(v))} hPa`}
          />
          <Line type="monotone" dataKey="Pressure" stroke="#a78bfa" dot={false} strokeWidth={2.5} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
